<div class="bg-contrast h-full w-full relative p-lg md:p-base overflow-auto">
  <mg-included-shops
    [shopsList]="data.shopsList"
    pillSize="s"
    (canceld)="dialogRef.close()"
  ></mg-included-shops>
</div>
